import TelemetryLogger from "factor-lib/services/logger/TelemetryLogger";
import ILogger from "factor-lib/services/logger/ILogger";
import CompositeLogger from "factor-lib/services/logger/CompositeLogger";
import IEnvConfig from "./IEnvConfig";
import WindowLogger from "factor-lib/services/logger/WindowLogger";

export const DevDataBackend = ({
    baseUrl: 'https://data-admin-api-dev-5s5itwtbza-ew.a.run.app',
    scope: 'api://c4153584-183e-4a9c-80f0-164e913b05a3/SingleScope'
});

export const devTelemetryProvider = (): ILogger => new TelemetryLogger('7e7c33be-af2c-4875-b0c6-4284007dd113');

const DevEnv: IEnvConfig = {

    logger: () => new CompositeLogger([devTelemetryProvider(), new WindowLogger(false)]),

    title: 'dev',
    swanClientId: 'SANDBOX_047f692f-2fb1-4f4f-8e6c-6c7e2cd01ef4',
    baseUrl: 'https://blue-island-07b32ed03.azurestaticapps.net',
    azureADClientId: '5b31ad1b-6f58-45ea-a1d1-a47c78d41d54',
    mainBackend: {
        baseUrl: 'https://factor-dev-admin-api.azurewebsites.net',
        scope: 'api://e9750ff5-0880-4ac5-851a-bff534c54840/access_as_user'
    },
    dataBackend: DevDataBackend,
    logMsalInfo: false
};

export default DevEnv;
